import { ApiError } from '../../api/errors';
import type { Subscription, SubscriptionPatch } from '../../domain/inventory';

export type SubscriptionEditDraft = Partial<
  Pick<
    Subscription,
    | 'contractName'
    | 'contractUrl'
    | 'notes'
    | 'numberOfSystems'
    | 'regions'
    | 'startTime'
    | 'endTime'
  >
>;

export const SUBSCRIPTION_FIELD_LABELS: Record<keyof SubscriptionEditDraft, string> = {
  contractName: 'Contract name',
  contractUrl: 'Contract URL',
  notes: 'Notes',
  numberOfSystems: 'Entitled systems',
  regions: 'Regions',
  startTime: 'Start date',
  endTime: 'End date',
};

export function buildSubscriptionPatch(
  subscriptionId: string,
  revision: number,
  draft: SubscriptionEditDraft,
): SubscriptionPatch {
  return { id: subscriptionId, revision, ...draft };
}

export function subscriptionEditErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.code === 'VALIDATION') {
    return 'Review the entitlement details and try again.';
  }
  return error instanceof Error ? error.message : 'The entitlements could not be saved.';
}
